import { IPublicClientApplication } from '@azure/msal-browser';
import { graphConfig } from '@/config/authConfig';
import { User } from '@/types/auth.types';
import { ApiClient } from '@/config/axios.config';

export class GraphService {
  private msalInstance: IPublicClientApplication;

  constructor(msalInstance: IPublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  async getProfile(): Promise<User> {
    const account = this.msalInstance.getActiveAccount();
    if (!account) {
      throw new Error('No active account! Please sign in.');
    }

    const response = await this.msalInstance.acquireTokenSilent({
      scopes: ['User.Read'],
      account: account,
    });

    return ApiClient.get<User>(graphConfig.graphMeEndpoint, {
      headers: {
        Authorization: `Bearer ${response.accessToken}`,
      },
    });
  }
}
